<div #addbutton>
    <p-splitButton label="{{this.defaultLabel}}" icon="pi pi-plus" [model]="segmentAddTypes" (onClick)="addDefaultSegment()" [appendTo]="addbutton"></p-splitButton>
</div>